module.exports = __webpack_public_path__ + "img/A3_HQ.c7d694fb.jpg";